/* eslint-disable react/no-unescaped-entities */
import clsx from 'clsx'
import React from 'react'
import styles from './index.module.scss'
import { useNavigate } from 'react-router-dom'
import { ButtonCommon } from '../../components'
import PageError from '../../assets/images/404.png'
import { useTranslation } from 'react-i18next'
export const NotFoundPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const role = localStorage.getItem('role') || ''
  const handleNavigate = () => {
    role === '9' ? navigate('/admin') : navigate('/')
  }
  return (
    <div className={clsx(styles.page__content)}>
      <div className={clsx(styles.wrap__page)}>
        <div className={clsx(styles.wrap__page__content)}>
          <div className={clsx(styles.image)}>
            <img src={PageError} alt="notfound" />
          </div>
          <p className={clsx(styles.description)}>{t('common.descriptionNotFound')}</p>
          <div>
            <ButtonCommon onClick={handleNavigate} className={clsx(styles.back__to__home)}>
              {t('common.btnNotFound')}
            </ButtonCommon>
          </div>
        </div>
      </div>
    </div>
  )
}